import * as React from 'react';
import { IPreviewFooterProps } from './types';
import './_PreviewFooter.scss';
import { Button } from 'kui';
import { PREVIEW_FOOTER_RESET } from './constants';

export function PreviewFooter ({
    isChanged,
    onReset,
}: IPreviewFooterProps) {
    return <>
        <Button
            variant={'secondary'}
            disabled={!isChanged}
            onClick={onReset}
        >
            {PREVIEW_FOOTER_RESET}
        </Button>
    </>
}
